module.exports = __webpack_public_path__ + "static/media/chatbox.6e8bc6bd.svg";